// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"888":"08214620","914":"b5dcfd15"}[chunkId] + ".js";
};